import React from 'react';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(4),
  },
}));

export default function PaperVoid(props)
{
  const classes = useStyles();
  return(
    <Grid className={classes.container} container justifyContent="center">
      <Paper className={classes.paper}>
        <Typography>発行元により、閲覧不可に設定されています。</Typography>
        <Typography>閲覧する必要がある場合、発行元に問い合わせください。</Typography>
      </Paper>
    </Grid>
  );
}